"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var transparencyButton_1 = __importDefault(require("./transparencyButton"));
var Advertising = /** @class */ (function (_super) {
    __extends(Advertising, _super);
    function Advertising() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Advertising.prototype.componentDidMount = function () {
        var _this = this;
        if (this.element) {
            var clickEventListener = function (event) {
                event.preventDefault();
                event.stopPropagation();
                if (_this.button) {
                    _this.button.click();
                }
                return false;
            };
            this.element.addEventListener('click', clickEventListener);
        }
        if (this.element) {
            var mousedownEventListener = function (event) {
                event.preventDefault();
                return false;
            };
            this.element.addEventListener('mousedown', mousedownEventListener);
        }
    };
    Advertising.prototype.render = function () {
        var _this = this;
        var _a = this.props, adObj = _a.adObj, marking = _a.marking, className = _a.className, style = _a.style, white = _a.white, uppercase = _a.uppercase, fontSize = _a.fontSize, top = _a.top, right = _a.right;
        var text;
        switch (marking) {
            case 'sponsor':
                text = 'Annonse';
                break;
            case 'partner':
                text = 'Annonsørinnhold';
                break;
            default:
                text = 'Annonsørinnhold';
                break;
        }
        return (React.createElement("div", { className: className, style: style, ref: function (element) { return (_this.element = element); } },
            React.createElement("span", { style: {
                    textTransform: uppercase ? 'uppercase' : 'none',
                    fontSize: fontSize,
                    fontWeight: 'bold',
                    fontStyle: 'normal',
                    fontStretch: 'normal',
                    lineHeight: '1.33',
                    letterSpacing: 'normal',
                    color: white ? '#ffffff' : '#767676',
                } }, text),
            React.createElement(transparencyButton_1.default, { adObj: adObj, style: {
                    width: '25px',
                    height: '25px',
                    position: 'absolute',
                    opacity: white ? 1 : 0.6,
                    right: right,
                    top: top,
                    zIndex: 1,
                    filter: white ? 'brightness(0) invert(1)' : '',
                }, 
                // white={white}
                ref: function (button) { return (_this.button = button); } })));
    };
    Advertising.defaultProps = {
        marking: 'partner',
        uppercase: true,
        fontSize: '12px',
        top: '2px',
        right: '3px',
    };
    return Advertising;
}(React.Component));
exports.default = Advertising;
